// extracted by mini-css-extract-plugin
module.exports = {"root":"Cover_root__boNvw","btns":"Cover_btns__1DaHM","cover":"Cover_cover__2qu-4"};